import React, { Component } from "react";
import LoginForm from "./LoginForm";
import { Link } from "react-router";
import SimplifiedLayout from "../SimplifiedLayout";
import { Grid, Col, Row } from "react-bootstrap";
import Helmet from "react-helmet";

class LoginPage extends Component {
    constructor() {
        super();
        this.state = { initialMessage: "" };
    }

    componentWillMount() {    	
        if (this.props.location.query["reason"] === "401" 
        	|| this.props.location.query["reason"] === "403"
        	|| this.props.location.query["reason"] === "error") {
            this.setState({ initialMessage: "Please log in first (required)" });
        }
    }

    render() {
        return (
            <div>
            	<Helmet title="Login"/>
                <SimplifiedLayout>
                    <div>
                        <Grid className="text-center">
                            <Row>
                                <Col sm={3} />
                                <Col sm={6}>
                                    <LoginForm
                                        initialMessage={
                                            this.state.initialMessage
                                        }
                                    />
                                </Col>
                                <Col sm={3} />
                            </Row>
                            <Row>
                                <Col sm={12} className="text-center">
                                    <Link to="/signup">Create account</Link>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </SimplifiedLayout>
            </div>
        );
    }
}

export default LoginPage;



// WEBPACK FOOTER //
// ./src/auth/LoginPage.js